
import { Vue } from 'nuxt-property-decorator'
import Component from 'nuxt-class-component'

@Component({
  middleware: 'notAuthenticated',
  components: {},
})
export default class LoginExternalLayout extends Vue {}
